import { Home } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "../atoms/Button";
import { Link } from "../atoms/Link";
import { EmptyState } from "../molecules/EmptyState";
import { CenteredCardLayout } from "../templates/CenteredCardLayout";

export interface NotFoundPageProps {
	homeHref?: string;
	className?: string;
}

function NotFoundPage({
	homeHref = "/",
	className,
}: NotFoundPageProps): ReactNode {
	return (
		<CenteredCardLayout className={className}>
			<EmptyState
				title="404 — Not Found"
				description="The page you're looking for doesn't exist or has been moved."
				icon={<Home className="h-12 w-12" aria-hidden="true" />}
				action={
					<Button asChild={true}>
						<Link
							href={homeHref}
							className="no-underline text-primaryForeground"
						>
							Back to Dashboard
						</Link>
					</Button>
				}
			/>
		</CenteredCardLayout>
	);
}
NotFoundPage.displayName = "NotFoundPage";

export default NotFoundPage;
export { NotFoundPage };
